import { MeteringPoint } from './metering-point.model';
import { MeteringPointGroup } from './metering-group.model';
import { MeteringType } from '@enums';

export class Invoice {
  invoiceId?: string;
  contract?: number;
  date?: string;
  status?: string;
  meteringPointId?: number;
  meteringPointName?: string;
  meteringPointAddress?: string;
  meteringPoint?: MeteringPoint;
  meteringPointGroup?: MeteringPointGroup;
  meteringType?: MeteringType;
  amount?: number;
  type?: string;
  payDate?: string;

  public static MockOne(invoiceId = '1390026308') {
    return { invoiceId } as Invoice;
  }

  public static MockMany() {
    return [Invoice.MockOne(), Invoice.MockOne('1390026309')];
  }
}

export enum InvoiceFilterColumns {
  InvoiceId = 'Fakturanummer',
  InvoiceDate = 'Datum',
  MeteringPoint = 'Anläggning',
  MeteringPointAddress = 'Adress',
  MeteringPointName = 'Kundnamn',
  PayDate = 'Förfallodatum'
}
